import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=2c8adbfb"
import script from "./MediaViewer.vue?vue&type=script&lang=ts"
export * from "./MediaViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports